import React, { Fragment } from 'react';
import { CalendarIcon } from 'lucide-react';
interface TimelineEvent {
  id: number;
  date: string;
  payer: string;
  title: string;
  type: string;
  impact: string;
}
interface PolicyChangeTimelineProps {
  events: TimelineEvent[];
}
const PolicyChangeTimeline: React.FC<PolicyChangeTimelineProps> = ({
  events
}) => {
  // Group events by month
  const groupedEvents: Record<string, TimelineEvent[]> = {};
  events.forEach(event => {
    const date = new Date(event.date);
    const monthYear = date.toLocaleString('default', {
      month: 'long',
      year: 'numeric'
    });
    if (!groupedEvents[monthYear]) {
      groupedEvents[monthYear] = [];
    }
    groupedEvents[monthYear].push(event);
  });
  return <div className="flow-root" data-id="element-158">
      <ul className="-mb-8" data-id="element-159">
        {Object.entries(groupedEvents).map(([monthYear, monthEvents], monthIndex) => <Fragment key={monthYear} data-id="element-160">
              <li className="relative pb-4" data-id="element-161">
                <div className="relative flex items-center space-x-3" data-id="element-162">
                  <div data-id="element-163">
                    <span className="h-8 w-8 rounded-full bg-blue-500 flex items-center justify-center ring-8 ring-white" data-id="element-164">
                      <CalendarIcon className="h-5 w-5 text-white" data-id="element-165" />
                    </span>
                  </div>
                  <div className="min-w-0 flex-1" data-id="element-166">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-167">
                      {monthYear}
                    </h3>
                  </div>
                </div>
              </li>
              {monthEvents.map((event, eventIndex) => <li key={event.id} className="relative pl-8 pb-8" data-id="element-168">
                  {eventIndex < monthEvents.length - 1 && <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" data-id="element-169"></span>}
                  <div className="relative flex items-start space-x-3" data-id="element-170">
                    <div data-id="element-171">
                      <div className={`relative px-1 ${event.type === 'negative' ? 'bg-red-100' : event.type === 'positive' ? 'bg-green-100' : 'bg-gray-100'} rounded-full flex items-center justify-center h-8 w-8 ring-8 ring-white`} data-id="element-172">
                        <div className={`h-2.5 w-2.5 rounded-full ${event.type === 'negative' ? 'bg-red-500' : event.type === 'positive' ? 'bg-green-500' : 'bg-gray-500'}`} data-id="element-173"></div>
                      </div>
                    </div>
                    <div className="min-w-0 flex-1 py-1.5" data-id="element-174">
                      <div className="text-sm text-gray-500" data-id="element-175">
                        <span className="font-medium text-gray-900" data-id="element-176">
                          {event.payer}
                        </span>{' '}
                        updated
                      </div>
                      <div className="mt-1 flex items-center justify-between" data-id="element-177">
                        <span className="text-sm font-medium text-gray-900" data-id="element-178">
                          {event.title}
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-179">
                          {event.date}
                        </span>
                      </div>
                      <div className="mt-2 flex items-center space-x-2" data-id="element-180">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${event.type === 'negative' ? 'bg-red-100 text-red-800' : event.type === 'positive' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-181">
                          {event.type.charAt(0).toUpperCase() + event.type.slice(1)}
                        </span>
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${event.impact === 'high' ? 'bg-red-100 text-red-800' : event.impact === 'medium' ? 'bg-amber-100 text-amber-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-182">
                          {event.impact.charAt(0).toUpperCase() + event.impact.slice(1)}{' '}
                          Impact
                        </span>
                      </div>
                    </div>
                    <div data-id="element-183">
                      <button className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-184">
                        View
                      </button>
                    </div>
                  </div>
                </li>)}
            </Fragment>)}
      </ul>
    </div>;
};
export default PolicyChangeTimeline;